import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';

import i18n from 'i18n-js';
import { isAndroid, isWeb, moderateScale, navigateTo, Popup } from '@helpers';
import { scale } from '@components/frame';

import TablerWrapper from '@components/auntification/tablerWrapper';
import {
  AUTH_LOGO_MARGIN_TOP_SMALL,
  AUTH_LOGO_MAX_WIDTH,
  AUTH_LOGO_OFFSET_FORM,
  AUTH_OFFSET_FORM_LARGE,
} from '../tablerWrapper/constants';
import Button from '@components/button/index';
import Logo from '@components/logo/index';

import { logOnboarding } from '@reducers/onBoarding';
import useStatusBar from '@components/common/useStatusBar';
import TouchableElement from '@components/common/touchableElement';
import ColorsWrapper from '@styles/colors';
import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';

import ChangeFactoryTime from './modals/changeFactoryTime';
import { modalFieldBg } from '@v2/pages/common/constants/base.constants';

const ValueLine = ({ C, value, onClick }) => {
  return (
    <TouchableElement
      onPress={() => {
        onClick();
      }}
    >
      {({ pressHoverColor, boxStyle }) => (
        <View
          style={[
            {
              paddingHorizontal: scale(15),
              justifyContent: 'space-between',
              alignItems: 'center',
              flexDirection: 'row',
              height: scale(41.5) - (isAndroid ? StyleSheet.hairlineWidth : 0),
              borderRadius: scale(10),
              backgroundColor: C(pressHoverColor(modalFieldBg)),
            },
            boxStyle,
          ]}
        >
          <View style={[{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', flex: 1 }]}>
            <View>
              <Text
                style={[
                  {
                    color: C(pressHoverColor('Label/Light/Primary')),
                    fontVariant: ['tabular-nums'],
                  },
                  font.Body,
                ]}
              >
                {i18n.t(value ? value : 'Select Time Zone')}
              </Text>
            </View>
            <View>
              <Svg icon="chevronRightLight" color="Label/Light/Quinary" width={scale(7)} height={scale(12)} />
            </View>
          </View>
        </View>
      )}
    </TouchableElement>
  );
};

const CreateAccount = (props) => {
  const { route, C, logOnboarding, onBoarding } = props;

  const scenario = route.params?.scenario;
  const data = route?.params?.data;

  const [factoryTimeZone, setFactoryTimeZone] = useState(onBoarding?.unregisteredConnector?.factoryTimezone || null);

  useStatusBar({ C });

  useEffect(() => {
    if (scenario === 'onBoarding' && !onBoarding?.code) {
      navigateTo('ConnectorSetup');
    }
  }, []);

  const submit = async () => {
    const props = { ...data, factoryTimeZone };
    switch (scenario) {
      case 'onBoarding': {
        logOnboarding(`Component: Enter factory time. Action: next`, { ...props, component: 'Enter factory time', action: 'Next' });
        navigateTo('FactoryLanguage', { data: props, scenario: 'onBoarding' });
        return;
      }
    }
  };

  const toggleFactoryTime = () => {
    Popup({
      Component: (p) => <ChangeFactoryTime {...{ ...p, selectedValue: factoryTimeZone, change: setFactoryTimeZone }} />,
    });
  };

  return (
    <TablerWrapper offset={AUTH_OFFSET_FORM_LARGE} keyboardAvoid>
      <Logo
        title={i18n.t('Factory Time Zone')}
        small
        marginTop={AUTH_LOGO_MARGIN_TOP_SMALL}
        maxWidth={AUTH_LOGO_MAX_WIDTH}
        offset={AUTH_LOGO_OFFSET_FORM}
        isBack
      />
      <View style={styles.inputContainer}>
        <View>
          <View style={{ paddingLeft: scale(15), marginTop: scale(26), marginBottom: scale(5) }}>
            <Text style={[font.Footnote, { color: C('Label/Light/Tertiary') }]}>{i18n.t('TIME ZONE OF YOUR FACTORY')}</Text>
          </View>
          <View>
            <ValueLine
              {...{
                C,
                value: factoryTimeZone,
                onClick: toggleFactoryTime,
              }}
            />
          </View>
        </View>
        <Button
          {...{
            name: i18n.t('Next'),
            disabled: !factoryTimeZone,
            onPress: submit,
          }}
        />
      </View>
    </TablerWrapper>
  );
};

export default connect(({ onBoarding }) => ({ onBoarding }), { logOnboarding })(ColorsWrapper(CreateAccount));

const INPUT_CONTAINER_HEIGHT = 334;
const INPUT_CONTAINER_TOP_MARGIN = 21;
const INPUT_CONTAINER_PHONE_WIDTH = '90%';

const styles = StyleSheet.create({
  inputContainer: {
    width: isWeb ? '100%' : INPUT_CONTAINER_PHONE_WIDTH,
    justifyContent: 'space-between',
    height: moderateScale(INPUT_CONTAINER_HEIGHT),
    marginTop: moderateScale(INPUT_CONTAINER_TOP_MARGIN),
  },
});
